import Vue from "vue";
import { timestampToReadableDate } from "@/filters/date.filter";
import { humanizeBytes } from "@/filters/bytes.filter";

Vue.filter("timestamp", timestampToReadableDate);
Vue.filter("humanizeBytes", humanizeBytes);
